var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDrawPoint = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c4a000",
    height: 11,
    rx: 2.01149,
    width: 11,
    x: -20,
    y: 13
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fcffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-15 14v2.0625c-.537663.111041-1.024662.383291-1.375.78125l-1.78125-1.03125-.5.875 1.78125 1.03125c-.082063.247432-.125.506395-.125.78125s.04294.533818.125.78125l-1.78125 1.03125.5.875 1.78125-1.03125c.352503.40042.832682.670182 1.375.78125v2.0625h1v-2.0625c.537663-.111041 1.024662-.383291 1.375-.78125l1.78125 1.03125.5-.875-1.78125-1.03125c.082063-.247432.125-.506395.125-.78125s-.04294-.533818-.125-.78125l1.78125-1.03125-.5-.875-1.78125 1.03125c-.352503-.40042-.832682-.670182-1.375-.78125v-2.0625zm.5 3.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19 19 9-.0096s0 0 0-2c0-2.9904-1-2.9904-4.5-2.9904s-4.5 0-4.5 3z",
    fillRule: "evenodd",
    opacity: 0.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#8cbe8c",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 3.125,
    stroke: "#4c4d4c",
    strokeOpacity: 0.933333,
    width: 5,
    x: 1.5,
    y: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 3.125,
    stroke: "#4b4c4b",
    strokeOpacity: 0.956863,
    width: 5,
    x: 8.5,
    y: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 3.125,
    stroke: "#4c4d4c",
    strokeOpacity: 0.933333,
    width: 5,
    x: 17.5,
    y: 3.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDrawPoint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/draw_point.14407600.svg";
export { ForwardRef as ReactComponent };